module.exports = __webpack_public_path__ + "img/923.e9034866.png";